import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'
import { INPUT_TYPES, InputType } from '@/components/forms/RunRiskCalibrationForm/enums'

export const DEFAULT_RISK = {
  FCAGF: ['risk'],
  FCDGF: ['risk'],
  FCPGF: ['risk', 'attributions', 'var', 'mtm'],
  LOWES: ['risk', 'var', 'mtm'],
}

export const defaultValues: {
  [K in InputType]: Omit<Partial<Extract<SchemaType, { input_type: K }>>, 'input_type'>
} = {
  [INPUT_TYPES.ALL_JOBS]: {
    push_to_db: false,
  },
  [INPUT_TYPES.DERIVED_METRICS]: {},
  [INPUT_TYPES.CUSTOM_STRATEGIES]: {},
  [INPUT_TYPES.VOLDIV_ADJUSTMENTS]: {},
  [INPUT_TYPES.CALIBRATION]: {
    push_to_db: false,
    config: 'strict',
  },
  [INPUT_TYPES.DEFAULT_RISK]: {
    funds: ['FCAGF', 'FCDGF', 'FCPGF', 'LOWES'],
    config: 'strict',
  },
  [INPUT_TYPES.CUSTOM_RISK]: {
    config: 'strict',
    reports_dct: {
      FCAGF: ['risk'],
      FCDGF: ['risk'],
      FCPGF: ['risk', 'attributions', 'var', 'mtm'],
      LOWES: ['risk', 'var', 'mtm'],
    },
  },
}
